import AOS from "aos";
import Vue from "vue";
import VShowSlide from 'v-show-slide'
import debounce from "lodash.debounce";
import {FunctionalCalendar} from 'vue-functional-calendar';
import axios from "axios";

Vue.use(VShowSlide)

document.addEventListener("DOMContentLoaded", function (event) {

  AOS.init();

  const mobileMenu = new Vue({
    el: '#mainhead',
    data: {
      menuOpen: false,
    },
    methods: {
      toggleMenu() {
        this.menuOpen = !this.menuOpen;
      },
      handleScroll(event) {
        this.isUserScrolling = (window.scrollY > 0);

        if (window.scrollY > 160) {
          document.getElementsByTagName('body')[0].classList.add('body--scrolled');
        } else {
          document.getElementsByTagName('body')[0].classList.remove('body--scrolled');
        }
      }
    },
    created() {
      this.handleDebouncedScroll = debounce(this.handleScroll, 100);
      window.addEventListener('scroll', this.handleDebouncedScroll);
    },

    beforeDestroy() {
      // I switched the example from `destroyed` to `beforeDestroy`
      // to exercise your mind a bit. This lifecycle method works too.
      window.removeEventListener('scroll', this.handleDebouncedScroll);
    }
  });

  if (document.getElementById("topiclist")) {
    const topicList = new Vue({
      el: '#topiclist',
      data: {
        openTopic: 0,
        filteredTopics: [],
      },
      methods: {
        toggleTopic(id) {
          this.openTopic = this.openTopic === id ? 0 : id;
        },
        isOpen(id) {
          return this.openTopic === id;
        },
      }
    })


  }
  if (document.getElementById("county-select")) {
    const select = new Vue({
      el: '#county-select',
      data: {
        selected: '',
      },
      methods: {
        change(event) {
          location.href = this.selected;
        }
      }
    })
  }
});

Vue.component('availability-calendar', {
  components: {
    FunctionalCalendar
  },
  props: [
    'excursion',
    'bookingurl'
  ],
  data: function () {
    return {
      calendarData: {},
      calendarConfigs: {
        sundayStart: false,
        dayNames: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        dateFormat: 'dd/mm/yyyy',
        isDatePicker: false,
        isDateRange: false,
        isMultiple: true,
        calendarsCount: 3,
        markedDates: [],
        hiddenElemets: ['leftAndRightDays'],
      },
      availabilityMap: {},
      currentInfo: '',
    }
  },
  mounted() {
    axios
      .get(this.bookingurl + '/availabilitymap/' + this.excursion + '/')
      .then(response => {
        this.availabilityMap = response.data.reduce((map, obj) => {
          map[obj.date] = obj.available;
          return map;
        }, {});
        this.reservedMap = response.data.reduce((map, obj) => {
          map[obj.date] = obj.reserved;
          return map;
        }, {});
        this.calendarConfigs.markedDates = response.data.map(date => {
          return {
            date: date.date,
            class: this.reservedMap[date.date] ? 'vfc-marked vfc-marked--reserved vfc-borderd' : 'vfc-marked vfc-borderd',
          }
        });

        document.querySelectorAll('.topic__availability__calendar').forEach(item => {
          item.addEventListener('mouseover', (e) => {
            if (this.currentInfo && e.target.classList.contains('vfc-marked')) {
              const currentDay = e.target;
              currentDay.setAttribute('title', this.currentInfo);
            }
          })
        });
      })
  },
  methods: {
    dayClicked: function (day) {
      if (this.reservedMap[day.date]) {
        alert('Dieser Tag ist im Moment reserviert.');
        return;
      }
      if (this.availabilityMap[day.date]) {
        const pattern = /(\d{1,2})\/(\d{1,2})\/(\d{4})/;
        const date = day.date.replace(pattern, '$3-$2-$1');
        const dt = new Date(date);//.toISOString();//.split('T')[0];
        const dateString = new Date(dt.getTime() - (dt.getTimezoneOffset() * 60000))
          .toISOString()
          .split("T")[0];
        location.href = this.bookingurl + "/booking/?excursion=" + this.excursion + "&day=" + dateString;
      }
    },
    dayMouseOver: function (date) {
      const availability = this.availabilityMap[date];
      const reserved = this.reservedMap[date];
      if (reserved) {
        this.currentInfo = 'im Moment reserviert';
      } else {
        if (availability) {
          this.currentInfo = 'verfügbar für ' + availability + ((availability > 1) ? ' Gruppen' : ' Gruppe');
        }
      }
    }
  },
  template: `
    <div v-if="calendarConfigs.markedDates.length">
      <FunctionalCalendar
          :configs="calendarConfigs"
          ref="Calendar"
          v-on:dayClicked="dayClicked"
          v-on:dayMouseOver="dayMouseOver"
      />
    </div>
    <p style="text-align: center;" v-else><strong>Im Moment sind keine Termine verfügbar.</strong></p>
  `
})